import cleanedFilename from '~/util/cleanedFilename';

export default {
  LABEL: `${cleanedFilename(__filename)}-label`,
};
